import React from 'react';

import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';

import LogActivity from './index';

import type { Activity } from 'bundles/apex/activities/types';
import type { SendEmailConfig } from 'bundles/apex/activities/send_email/types';

interface Props {
  activity?: Activity;
  aiEnabled?: boolean;
  parentId?: number;
  parentType?: string;
  fromEmail?: string;
  sendEmail?: SendEmailConfig;
  path: string;
  show: boolean;
  subjectName?: string;
  onHide: () => void;
  onLogged: (activity: Activity) => void;
}

export default function LogActivityModal({
  activity,
  aiEnabled,
  parentId,
  parentType,
  fromEmail,
  sendEmail,
  path,
  show,
  subjectName,
  onHide,
  onLogged,
}: Props) {
  if (!show) return null;

  return (
    <Modal open onClose={onHide}>
      <Modal.Content size="lg">
        <Modal.Body>
          <LogActivity
            activity={activity}
            aiEnabled={aiEnabled}
            fromEmail={fromEmail}
            parentId={parentId}
            parentType={parentType}
            path={path}
            sendEmail={sendEmail}
            subjectName={subjectName}
            onClose={onHide}
            onLogged={onLogged}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
